import httpClient from './httpClient'
const baseAnalyticsUrl = 'https://data.pandavideo.com'

export default {
  async getTrafficBandwidth(startDate, endDate, type = 'general') {
    let ret = await httpClient.get(
      `/analytics/traffic?type=${type}&start_date=${startDate}&end_date=${endDate}`
    )
    return ret
  },
  async getVideoTrafficBandwidth(startDate, endDate, videoId) {
    let ret = await httpClient.get(
      `/analytics/traffic?start_date=${startDate}&end_date=${endDate}&video_id=${videoId}`
    )
    return ret
  },
  async getVideoTrafficBandwidthTypeAll(startDate, endDate, videoId) {
    let ret = await httpClient.get(
      `/analytics/traffic?type=all&start_date=${startDate}&end_date=${endDate}&video_id=${videoId}`
    )
    return ret
  },
  async getVideoMetrics(videoId, startDate, endDate) {
    let url = `/analytics/video/${videoId}?a=1`
    if (startDate) {
      url += `&start_date=${startDate}`
    }
    if (endDate) {
      url += `&end_date=${endDate}`
    }

    let ret = await httpClient.get(url)
    return ret
  },
  async getVideoMetricsV2(videoId, startDate, endDate) {
    let url = `${baseAnalyticsUrl}/retention/${videoId}?a=1`
    if (startDate) {
      url += `&start_date=${startDate}`
    }
    if (endDate) {
      url += `&end_date=${endDate}`
    }

    let ret = await httpClient.get(url)
    return ret
  },
  async getVideoDataV2(videoId, startDate, endDate) {
    let url = `${baseAnalyticsUrl}/general/${videoId}?type=video`
    if (startDate) {
      url += `&start_date=${startDate}`
    }
    if (endDate) {
      url += `&end_date=${endDate}`
    }
    let ret = await httpClient.get(url)
    return ret
  },
  async getVideosDataV2(startDate, endDate, videos) {
    const { data } = await httpClient.post(
      `analytics/video_v2?start_date=${startDate}&end_date=${endDate}&type=many`,
      { video_ids: videos }
    )
    return data
  },
  async getAccountMetrics(startDate, endDate) {
    let url = '/analytics/video?a=1'
    if (startDate) {
      url += `&start_date=${startDate}`
    }
    if (endDate) {
      url += `&end_date=${endDate}`
    }
    let ret = await httpClient.get(url)
    return ret
  },
  async getCountryMetrics(startDate, endDate) {
    let url = `${baseAnalyticsUrl}/country?granularity=total`
    if (startDate) {
      url += `&start_date=${startDate}`
    }
    if (endDate) {
      url += `&end_date=${endDate}`
    }
    let ret = await httpClient.get(url)
    return ret
  },
  async getCountryMetricsFromVideo(videoId, startDate, endDate) {
    let url = `${baseAnalyticsUrl}/country/${videoId}?granularity=total`
    if (startDate) {
      url += `&start_date=${startDate}`
    }
    if (endDate) {
      url += `&end_date=${endDate}`
    }
    let ret = await httpClient.get(url)
    return ret
  },
  async getRegionMetrics(startDate, endDate, country) {
    let url = `${baseAnalyticsUrl}/region?granularity=total&country=${country}`
    if (startDate) {
      url += `&start_date=${startDate}`
    }
    if (endDate) {
      url += `&end_date=${endDate}`
    }
    let ret = await httpClient.get(url)
    return ret
  },
  async getRegionMetricsFromVideo(videoId, startDate, endDate, country) {
    let url = `${baseAnalyticsUrl}/region/${videoId}?granularity=total&country=${country}`
    if (startDate) {
      url += `&start_date=${startDate}`
    }
    if (endDate) {
      url += `&end_date=${endDate}`
    }
    let ret = await httpClient.get(url)
    return ret
  },
  async getCityMetrics(startDate, endDate, country, region) {
    let url = `${baseAnalyticsUrl}/city?granularity=total&region=${region}&country=${country}`
    if (startDate) {
      url += `&start_date=${startDate}`
    }
    if (endDate) {
      url += `&end_date=${endDate}`
    }
    let ret = await httpClient.get(url)
    return ret
  },
  async getCityMetricsFromVideo(videoId, startDate, endDate, country, region) {
    let url = `${baseAnalyticsUrl}/city/${videoId}?granularity=total&region=${region}&country=${country}`
    if (startDate) {
      url += `&start_date=${startDate}`
    }
    if (endDate) {
      url += `&end_date=${endDate}`
    }
    let ret = await httpClient.get(url)
    return ret
  },
  async getSingleVideoAnalytics(videoId, startDate, endDate) {
    let url = `${baseAnalyticsUrl}/general/${videoId}?`
    if (startDate) {
      url += `&start_date=${startDate}`
    }
    if (endDate) {
      url += `&end_date=${endDate}`
    }
    let ret = await httpClient.get(url)
    return ret
  },
  async getSingleVideoMetrics(videoId, startDate, endDate) {
    let url = `${baseAnalyticsUrl}/retention/${videoId}?`
    if (startDate) {
      url += `&start_date=${startDate}`
    }
    if (endDate) {
      url += `&end_date=${endDate}`
    }
    let ret = await httpClient.get(url)
    return ret
  },
  async getAccountRetention(startDate, endDate) {
    let url = `${baseAnalyticsUrl}/retention?`
    if (startDate) {
      url += `&start_date=${startDate}`
    }
    if (endDate) {
      url += `&end_date=${endDate}`
    }
    let ret = await httpClient.get(url)
    return ret
  },
  async getAccountMetricsV2(startDate, endDate) {
    let url = `${baseAnalyticsUrl}/general?`
    if (startDate) {
      url += `&start_date=${startDate}`
    }
    if (endDate) {
      url += `&end_date=${endDate}`
    }
    let ret = await httpClient.get(url)
    return ret
  },
  async getRanking(startDate, endDate) {
    let url = `${baseAnalyticsUrl}/ranking?`
    if (startDate) {
      url += `&start_date=${startDate}`
    }
    if (endDate) {
      url += `&end_date=${endDate}`
    }
    let ret = await httpClient.get(url)
    return ret
  },
  async getRankingV2(date) {
    let ret = await httpClient.get(
      `${baseAnalyticsUrl}/video_v2?type=ranking${
        date && `&start_date=${date}&end_date=${date}`
      }`
    )
    return ret
  },
  async getDevicesMetrics(startDate, endDate) {
    let url = `${baseAnalyticsUrl}/os?`
    if (startDate) {
      url += `&start_date=${startDate}`
    }
    if (endDate) {
      url += `&end_date=${endDate}`
    }
    let ret = await httpClient.get(url)
    return ret
  },
  async getSingleDeviceMetrics(videoId, startDate, endDate) {
    let url = `${baseAnalyticsUrl}/os/${videoId}?`
    if (startDate) {
      url += `&start_date=${startDate}`
    }
    if (endDate) {
      url += `&end_date=${endDate}`
    }
    let ret = await httpClient.get(url)
    return ret
  },
  async getBrowsersMetrics(startDate, endDate) {
    let url = `${baseAnalyticsUrl}/browser?`
    if (startDate) {
      url += `&start_date=${startDate}`
    }
    if (endDate) {
      url += `&end_date=${endDate}`
    }
    let ret = await httpClient.get(url)
    return ret
  },
  async getSingleBrowsersMetrics(videoId, startDate, endDate) {
    let url = `${baseAnalyticsUrl}/browser/${videoId}?`
    if (startDate) {
      url += `&start_date=${startDate}`
    }
    if (endDate) {
      url += `&end_date=${endDate}`
    }
    let ret = await httpClient.get(url)
    return ret
  },
  async getReferencesMetrics(startDate, endDate) {
    let url = `${baseAnalyticsUrl}/referrer?`
    if (startDate) {
      url += `&start_date=${startDate}`
    }
    if (endDate) {
      url += `&end_date=${endDate}`
    }
    let ret = await httpClient.get(url)
    return ret
  },
  async getSingleReferencesMetrics(videoId, startDate, endDate) {
    let url = `${baseAnalyticsUrl}/referrer/${videoId}?`
    if (startDate) {
      url += `&start_date=${startDate}`
    }
    if (endDate) {
      url += `&end_date=${endDate}`
    }
    let ret = await httpClient.get(url)
    return ret
  },
  async getRealtime(
    bbox,
    zoom,
    time_range,
    cluster_id,
    selected_videos = null
  ) {
    let url = `${baseAnalyticsUrl}/realtime?bbox=${bbox}&zoom=${zoom}&time_range=${time_range}`
    if (
      selected_videos &&
      Array.isArray(selected_videos) &&
      selected_videos.length > 0
    ) {
      url += `&selected_videos=${selected_videos.join(',')}`
    }
    if (cluster_id) {
      url += `&cluster_id=${cluster_id}`
    }
    let ret = await httpClient.get(url)
    return ret
  },
  async getRealtimeUser(user_id, video_external_id) {
    let url = `${baseAnalyticsUrl}/realtime?user_id=${user_id}&video_external_id=${video_external_id}`
    let ret = await httpClient.get(url)
    return ret
  },
  async getGeneralExternalPlays(start_date, end_date) {
    const { data } = await httpClient.get(
      `${baseAnalyticsUrl}/billing/external_plays?start_date=${start_date}&end_date=${end_date}`
    )
    return data
  },
  async getUsersMetrics(startDate, endDate) {
    let url = `${baseAnalyticsUrl}/users`
    if (startDate) {
      url += `?start_date=${startDate}`
    }
    if (endDate) {
      url += `&end_date=${endDate}`
    }

    let ret = await httpClient.get(url)
    return ret
  },
  // type: general, download, drm
  async getTrafficInRankByType(startDate, endDate, type) {
    const url = `/analytics/traffic/?rank_videos=11&start_date=${startDate}&end_date=${endDate}&type=${type}`

    return await httpClient.get(url)
  },
  // type: general, download, drm
  async getTrafficBandwidthByType(startDate, endDate, type) {
    const url = `/analytics/traffic?type=general&start_date=${startDate}&end_date=${endDate}&type=${type}`
    return await httpClient.get(url)
  },
  async getVideoTraffic(videoId, dates, type = 'all') {
    const ret = await httpClient.get(
      `/analytics/traffic?video_id=${videoId}&start_date=${dates[0]}&end_date=${dates[1]}&type=${type}`
    )
    return ret
  },
}
